<div class="flex pb-2 items-center justify-between">
  <span class="overline-o2 my-2">{{title}}</span>
  <app-button-link *ngIf="!disabled" (click)="delete.emit()" [disabled]="disabled" [style]="'warn'" iconLeft="trash"></app-button-link>
</div>
<div [ngClass]="{'nested-container': margin}">
  <ng-content></ng-content>
</div>
